/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadMedication } from './LeadMedication';
import {
    LeadMedicationFromJSON,
    LeadMedicationFromJSONTyped,
    LeadMedicationToJSON,
} from './LeadMedication';

/**
 * 
 * @export
 * @interface FindMedicationsForLead200Response
 */
export interface FindMedicationsForLead200Response {
    /**
     * 
     * @type {Array<LeadMedication>}
     * @memberof FindMedicationsForLead200Response
     */
    data?: Array<LeadMedication>;
}

/**
 * Check if a given object implements the FindMedicationsForLead200Response interface.
 */
export function instanceOfFindMedicationsForLead200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindMedicationsForLead200ResponseFromJSON(json: any): FindMedicationsForLead200Response {
    return FindMedicationsForLead200ResponseFromJSONTyped(json, false);
}

export function FindMedicationsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindMedicationsForLead200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadMedicationFromJSON)),
    };
}

export function FindMedicationsForLead200ResponseToJSON(value?: FindMedicationsForLead200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadMedicationToJSON)),
    };
}

